import UpdateTransaction from "../components/UpdateTransaction";
function Edit() {
  return (
    <section>
      <h3>Update this transaction</h3>
      <UpdateTransaction />
    </section>
  );
}

export default Edit;
